var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.TextAreaField = (function ($, _, Backbone, TextAreaField) {

	TextAreaField = Curriculog.ProposalForm.Field.extend({

		/**
		 * Used to return the value of the field
		 *
		 * @returns {String}
		 */
		getValue: function() {
			var $input = this.getInput();

			if (this.model.get('showMarkup')) {
				return this.model.get('value');
			}

			if (this.mode == 'edit') {
				return $input.val();
			}

			return $input.html();
		},

		/**
		 * A throttled function that updates the 'unsaved changes' cache. This
		 * function can be called as often as necessary without concern for
		 * computation overhead.
		 */
		detectChanges: function(){
			this._unsaved_changes = $('<div />').html(this.getValue()).text().trim() != this.model.get('value');

			// highlight the field if it has unsaved changes
			if (this._unsaved_changes) {
				this.$el.addClass('field-unsaved');
			} else {
				this.$el.removeClass('field-unsaved');
			}

		},

		/**
		 * Used to set the value of the field
		 *
		 * @param {String} value - the new value
		 */
		setValue: function(value) {
			var $input = this.getInput();

			if (this.mode == 'edit') {
				return $input.val(value);
			}

			return $input.html(value);
		},

		/**
		 * Refocuses the text area when switching to edit mode
		 */
		afterEdit: function() {
			this.getInput().focus();
			return Curriculog.ProposalForm.Field.prototype.afterEdit.call(this);
		}

	});

	return TextAreaField;

})($, _, Backbone, Curriculog.ProposalForm.TextAreaField || {});
